import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

export default function MiniToggleButtonGroup({ buttons, className, exclusive = true, onChange, value }) {
  return (
    <ToggleButtonGroup
      className={className}
      color="primary"
      css={({ palette }) => ({
        '& > button': {
          padding: '2px 5px',
          '&:first-of-type': { borderRadius: '8px 0 0 8px' },
          '&:last-of-type': { borderRadius: '0 8px 8px 0' },
          '&:only-of-type': { borderRadius: 8 },
          '&.Mui-selected': { borderColor: palette.primary.main, color: palette.primary.medium },
        },
      })}
      exclusive={exclusive}
      onChange={(_, newValue) => newValue !== null && onChange(newValue)}
      size="small"
      value={value}
    >
      {buttons.map(({ label, value }) => (
        <ToggleButton key={value} value={value}>
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
